import { takeLatest } from 'redux-saga/effects';
import { loadTopBets } from './loadTopBets';
import {
  CHANGE_OFFER_PRICE,
  LOAD_PUBLISH_TERMS_SUCCESS,
  SELECT_PUBLISH_TERMS_SERVICE,
  RELOAD_TOP_BETS,
} from '../../reducers';

export function* topBetsSagas() {
  yield takeLatest(
    [
      LOAD_PUBLISH_TERMS_SUCCESS,
      SELECT_PUBLISH_TERMS_SERVICE,
      CHANGE_OFFER_PRICE,
      RELOAD_TOP_BETS,
    ],
    loadTopBets,
  );
}
